import BaseSubscription from './BaseSubscription';
import { logInfo, logError } from './services';
import {
  detectBrowser,
  getFromLocalStorage,
  setToLocalStorage,
} from './../utils/utilsGlobal';

import notificationSound from './../../public/assets/audio/notification.mp3';


export const SOUND_NOTIFICATIONS_TOGGLE_MUTE = 'SOUND_NOTIFICATIONS_TOGGLE_MUTE';


export default class SoundNotifications extends BaseSubscription {

  isMuted = false;

  constructor(){
    super();
    this.isMuted = getFromLocalStorage('IS_MUTED');

    window.addEventListener('storage', this.onLocalStorageChange);
    document.body.addEventListener('click', this.unlockPlayNotificationSoundOnUserGesture);
  }

  onLocalStorageChange = (e) => {
    if (e.key === 'IS_MUTED') {
      const isMuted = getFromLocalStorage('IS_MUTED');
      this.toggleMute({ isMuted });
    }
  };

  toggleMute = ({ isMuted } = {}) => {
    if (this.isMuted !== isMuted) {
      this.isMuted = isMuted;
      setToLocalStorage('IS_MUTED', isMuted);
      this.triggerEvent(SOUND_NOTIFICATIONS_TOGGLE_MUTE, isMuted);
    }
  };

  /**
   * Prevents browser from muting audio autoplay
   * @see https://medium.com/@curtisrobinson/how-to-auto-play-audio-in-safari-with-javascript-21d50b0a2765
   */
  unlockPlayNotificationSoundOnUserGesture = (e) => {
    const audio = new Audio(notificationSound);
    audio.play().then(() => {
      audio.pause();
      audio.currentTime = 0;
    });

    // In Firefox, click on textarea doesn't unlock autoplay
    const clickOnTextareaInFirefox = detectBrowser() === 'firefox' && e.target.tagName === 'TEXTAREA';
    if (!clickOnTextareaInFirefox) {
      document.body.removeEventListener('click', this.unlockPlayNotificationSoundOnUserGesture);
    }
  };

  playNotificationSound = () => {
    if (!this.isMuted) {
      const notification = new Audio(notificationSound);
      notification.play().then(() => {
        logInfo('SoundNotifications: successfully played notification sound');
      })
      .catch(error => {
        logError('SoundNotifications: ' + error.message, { error });
      });
    }
  }
}
